import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, brl, formatApiError } from "@/lib/api";
import { DatePicker } from "@/components/DatePicker";

const DIALOG_CLS = "bg-[#111827] border-[#1F2937] text-[#F9FAFB] max-w-lg";

const run = async (fn, ok, done) => {
  try { await fn(); toast.success(ok); done(); }
  catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
};

export const ConfirmPaymentDialog = ({ o, open, onClose, onDone }) => {
  const [note, setNote] = useState("");
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className={DIALOG_CLS} data-testid="confirm-payment-dialog">
        <DialogHeader>
          <DialogTitle>Confirmar pagamento · {o.id}</DialogTitle>
          <DialogDescription className="text-[#9CA3AF]">Confira na SUA conta Mercado Pago um pagamento aprovado de <b>{brl(o.amount_cents)}</b> ({o.plan_label}). Comprovante enviado pelo cliente não é confirmação.</DialogDescription>
        </DialogHeader>
        <Textarea value={note} onChange={(e) => setNote(e.target.value)} placeholder="Nº da operação no Mercado Pago / observação (opcional)" className="input-dark" data-testid="confirm-payment-note" />
        <DialogFooter>
          <Button className="btn-primary" onClick={() => run(() => api.post(`/orders/${o.id}/confirm-payment`, { note }), "Pagamento confirmado", onDone)} data-testid="confirm-payment-submit">Conferi — confirmar pagamento</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export const ConfirmActivationDialog = ({ o, open, onClose, onDone }) => {
  const [f, setF] = useState({ expires_at: "", digital_user: o.digital_user || "", digital_id: o.digital_id || "", note: "" });
  const submit = () => {
    if (!f.expires_at) return toast.error("Informe o vencimento exibido no Digital+");
    run(() => api.post(`/orders/${o.id}/confirm-activation`, f), "Ativação confirmada", onDone);
  };
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className={DIALOG_CLS} data-testid="confirm-activation-dialog">
        <DialogHeader>
          <DialogTitle>Confirmar ativação · {o.id}</DialogTitle>
          <DialogDescription className="text-[#9CA3AF]">No Digital+: localize o cadastro, ajuste para <b>{o.screens} tela(s)</b>, renove por <b>{o.months} mês(es)</b> e confira status e vencimento. Depois preencha abaixo.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <Input value={f.digital_user} onChange={(e) => setF({ ...f, digital_user: e.target.value })} placeholder="Login do cliente no Digital+" className="input-dark font-mono" data-testid="activation-login-input" />
          <Input value={f.digital_id} onChange={(e) => setF({ ...f, digital_id: e.target.value })} placeholder="ID do cliente no Digital+ (opcional)" className="input-dark font-mono" data-testid="activation-id-input" />
          <div className="flex items-center gap-3"><span className="text-sm text-[#9CA3AF]">Vencimento real:</span><DatePicker value={f.expires_at} onChange={(v) => setF({ ...f, expires_at: v })} testId="activation-expiry-input" disablePast /></div>
          <Textarea value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} placeholder="Observação (opcional)" className="input-dark" data-testid="activation-note" />
        </div>
        <DialogFooter>
          <Button className="btn-primary" onClick={submit} data-testid="confirm-activation-submit">Confirmar ativação</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export const NoteDialog = ({ o, open, onClose, onDone, kind }) => {
  const [note, setNote] = useState("");
  const manual = kind === "manual";
  const submit = () => {
    if (manual && note.trim().length < 3) return toast.error("Descreva o motivo");
    run(() => api.post(`/orders/${o.id}/${manual ? "manual" : "cancel"}`, { note }), manual ? "Enviado para intervenção manual" : "Pedido cancelado", onDone);
  };
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className={DIALOG_CLS} data-testid={`${kind}-dialog`}>
        <DialogHeader><DialogTitle>{manual ? "Encaminhar para intervenção manual" : "Cancelar pedido"} · {o.id}</DialogTitle></DialogHeader>
        <Textarea value={note} onChange={(e) => setNote(e.target.value)} placeholder={manual ? "Motivo (obrigatório)" : "Motivo (opcional)"} className="input-dark" data-testid={`${kind}-note`} />
        <DialogFooter><Button className={manual ? "btn-primary" : "bg-red-600 hover:bg-red-500 text-white"} onClick={submit} data-testid={`${kind}-submit`}>{manual ? "Encaminhar" : "Cancelar pedido"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
